import { buildSchemaConfigReadoutGroupsAPI } from "@/services/api.services";

import { SavedObject } from "../commonModels";

export type RequestedAttribute = {
    attributeName: string;
};

export type ThingFilter = {
    [key: string]: unknown;
};

export type ReadoutGroup = {
    name: string;
    description: string | null;
    experimentCode: string | null;
    protocolCode: string | null;
    schemaConfigId: string | null;
    parentReadoutGroupId: string | null;
    thingSchemaId: string;
    requestedAttributes: RequestedAttribute[];
    filterEntryRelationAttribute: string | null;
    filterOnSequenceNumber: boolean;
    filter: ThingFilter | null;
    recordTimeWithMeasurements: boolean;
    isDefaultForAdHocTask: boolean;
};

export type SavedReadoutGroup = ReadoutGroup & SavedObject<string>;

export const readoutGroupsAPI = {
    bySchemaConfig: (schemaConfigId: string) => {
        return buildSchemaConfigReadoutGroupsAPI(schemaConfigId);
    },
};
